const config = {
    baseUrl: 'https://www.home-huntadmin.co.uk',
    // baseImageUrl: 'http://143.198.114.44',
    // baseUrl: 'http://143.198.114.44',
    // baseUrl: 'http://localhost:5000',
    googleMapAPIKey: "AIzaSyCX2y23lkwti4hjdH-OGJ2yrzTitQ6r_vY",
    mapZoom: 15
}
export default config;